exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div#carouselExampleIndicators {\n  z-index: 0;\n  margin-bottom: 40px; }\n  div#carouselExampleIndicators div.carousel-inner div.carousel-item div.carousel-caption h3 {\n    font-size: 40px; }\n  div#carouselExampleIndicators div.carousel-inner div.carousel-item div.carousel-caption p {\n    font-size: 18px;\n    margin-bottom: 10vh;\n    color: #ffffff; }\n\ndiv.altHeader {\n  height: 360px;\n  margin-bottom: 40px;\n  background: url(" + require("../../../assets/img/aboutHeaderBg.jpg") + ") center center no-repeat; }\n\ndiv.altHeaderIK {\n  height: 360px;\n  margin-bottom: 40px;\n  background: url(" + require("../../../assets/img/humanResourcesHeaderBg.jpg") + ") center center no-repeat; }\n\ndiv.altHeaderServices {\n  height: 360px;\n  margin-bottom: 40px;\n  background: url(" + require("../../../assets/img/servicesHeaderBg.jpg") + ") center center no-repeat; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/share/slider/slider.component.scss
// module id = ../../../../../src/app/share/slider/slider.component.scss
// module chunks = main